import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
 import ContractorTransactionsPage from 'dashboard/userData/contractorTransactions/ContractorTransactionsPage';
import {
    makeRequest,
    dispatchAction,
    displayMessage
} from 'actions';
import {
    Row,
    Col,
    Tabs,
    Tab,
    Form,
    FormGroup,
    Checkbox,
    Modal,
    ControlLabel,
    FormControl,
    Button
} from 'react-bootstrap';
import Select   from 'react-select'
import {
    FETCH_ADMIN_USER_TIME_TRACKING,
    CLEAR_SELECTED_USER_TIME_TRACKING,
    ADD_SELECTED_USER_TIME_TRACKING,
} from "actions/actionTypes";
import queryString from 'query-string'
 import {prepareSelectOptionsList, convertToHoursAndMinutes} from 'util/Utils';
  import ContractorReportsPage from "./ContractorReports/ContractorReportsPage";
import  KPIReportsPage from "./KPIReportsPage";
import  AMTSalesPage from "./AMT/AMTSalesPage";
import {checkValidDates, fetchAllContractorsList}  from 'shared/sharedMethods';

import config from  '../../../config';




class AdminReportsPage extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }


    constructor(props, context) {
        super(props, context);
        var defaultTab =  '/reports'


        if (_.get(this.props.location.query,'tab') == 'kpi'){
              defaultTab = '/kpi_reports'
        }else if (_.get(this.props.location.query,'tab') == 'atm'){
            defaultTab = '/atm'
        }
         this.state = {
            pending: false,
            totalDuration: 0,
            TimeTrackingStartTime: '',
            TimeTrackingEndTime: '',
            currentPage: _.isUndefined(this.props.location.query.page) ? 0 : parseInt(this.props.location.query.page) - 1,
            showModal: false,
            selectAllRecords: false,
            defaultTab: defaultTab,
            contractorsOptionsList: []
        };
        this.searchBox = false;
    };

    componentDidMount() {
        if (_.size(_.intersection(this.props.userReducer.user.Roles, [ 'Administrator'])) > 0) {

            fetchAllContractorsList.call(this)
            this.setState({
                contractorsOptionsList: prepareSelectOptionsList(this.props.allContractorsList.data, {
                    label: 'UserFullName',
                    value: '_id'
                })
            })
        }
        if (this.state.defaultTab == '/time-tracking') {
            var queryParams = queryString.parse(this.props.location.search);
            var params = {
                'page': _.isUndefined(queryParams.page) || parseInt(queryParams.page) <= 1 ? 1 : parseInt(queryParams.page),
                perPage: _.isUndefined(queryParams.perPage) ? config.table.numberPerPage : parseInt(queryParams.perPage),
                doNotUpdateUrlString: true,
            }
            if (!_.isUndefined(queryParams.sortBy)) {
                params.sortBy = queryParams.sortBy
            }
            if (!_.isUndefined(queryParams.searchText)) {
                params.searchText = queryParams.searchText
            }
            this.search(params)
        }
    }

    componentWillReceiveProps(nextProps) {
        // if (_.size(nextProps.allContractorsList.data) !== _.size(this.props.allContractorsList.data)) {
        //     console.log('contractors receive', _.filter(nextProps.allContractorsList.data, {Contractor: true}));
        //     this.setState({
        //         contractorsOptionsList: prepareSelectOptionsList(nextProps.allContractorsList.data, {
        //             label: 'UserFullName',
        //             value: '_id'
        //         })
        //     })
        //
        //
        // }
    }
    render() {

        //  console.log('searchbox in', this.refs.searchBox, this.refs.searchBox ? this.refs.searchBox.state.filterOptions.perPage : undefined,);
        return (
            <div >
                {( config.checkAccessRights.call(this,{ resources:['contractors_reports_view','KPI_reports_view','AMT_page']})) ?
                <Tabs className="top20" defaultActiveKey={this.state.defaultTab} id="reports">
                    {config.checkAccessRights.call(this, {resources: ['contractors_reports_view' ]}) &&
                    <Tab eventKey={'/reports'} unmountOnExit={true} title="Contractor">
                        <ContractorReportsPage location={this.props.location}></ContractorReportsPage>
                    </Tab>
                    }
                    {config.checkAccessRights.call(this, {resources: ['KPI_reports_view']}) &&
                    <Tab eventKey={'/kpi_reports'} unmountOnExit={true} title="KPI Report">
                        <KPIReportsPage  {...this.props} ></KPIReportsPage>
                    </Tab>
                    }
                    {config.checkAccessRights.call(this, {resources: ['AMT_page']}) &&
                    <Tab eventKey={'/atm'} unmountOnExit={true} title="AMT">
                        <AMTSalesPage  {...this.props} ></AMTSalesPage>
                    </Tab>
                    }
                </Tabs>
                    : <div>
                        {_.size(_.intersection(_.get(this.props, 'userReducer.user.Roles', []), ['AMT Team'])) ?
                            <AMTSalesPage  {...this.props} ></AMTSalesPage>:
                            < ContractorReportsPage location={this.props.location}></ContractorReportsPage>
                        }
                    </div>
                }

            </div >
        );

    }
}

function mapStateToProps(state, props) {
    return {
        allContractorsList: state.allContractorsList,
        userReducer: state.userReducer,
        adminUsersData: state.adminUsersData,
    };
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators({makeRequest, dispatchAction, displayMessage}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminReportsPage);
